import { ILead } from "../../../models/Lead";
import ClickToEdit from "../../shared/ClickToEdit";
import LeadPaymentDetails from "../LeadInformation/LeadPaymentDetails";

export default function LeadPaymentDetailsTab({ lead }: { lead: ILead }) {
  return (
    <div className="[&>*]:shadow-none [&>*]:border-0 [&>*]:rounded-none">
      <ClickToEdit name="Payment Details">
        <LeadPaymentDetails lead={lead} />
      </ClickToEdit>
    </div>
  );
}
